import { LazyImage } from "components/UI/lazyImage";
import { SkeletonSquare } from "components/UI/skeletonExport";
import { Autoplay, EffectFade, Navigation, Pagination } from "swiper";
import { SwiperSlide } from "swiper/react/swiper-react";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import { CustomSwiper } from "./styles";

export const Slider = ({ list, loading }) => {
  if (loading) {
    return <SkeletonSquare />;
  }
  return (
    <CustomSwiper
      spaceBetween={30}
      effect={"fade"}
      navigation={false}
      pagination={{ clickable: true }}
      autoplay={{
        delay: 2000,
        disableOnInteraction: false,
      }}
      modules={[EffectFade, Navigation, Pagination, Autoplay]}
      className="mySwiper"
    >
      {list?.map((item, index) => (
        <SwiperSlide key={`${index}-${item.alt}`}>
          <LazyImage src={item.img} alt={item.alt} />
        </SwiperSlide>
      ))}
    </CustomSwiper>
  );
};
